'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ = require('../');

var _Header = require('./components/Header');

var _Body = require('./components/Body');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Modal = function Modal(_ref) {
  var active = _ref.active,
      fullscroll = _ref.fullscroll,
      onModalClose = _ref.onModalClose,
      dialogLeft = _ref.dialogLeft,
      size = _ref.size,
      noscroll = _ref.noscroll,
      closeFill = _ref.closeFill,
      className = _ref.className,
      children = _ref.children,
      props = (0, _objectWithoutProperties3.default)(_ref, ['active', 'fullscroll', 'onModalClose', 'dialogLeft', 'size', 'noscroll', 'closeFill', 'className', 'children']);

  return _react2.default.createElement('div', (0, _extends3.default)({
    className: (0, _classnames2.default)(className, 'mod-Modal', {
      'mod-Modal-active': active,
      'mod-Modal-fullscroll': fullscroll
    })
  }, props), _react2.default.createElement('div', { className: 'mod-Modal_Overlay', onClick: function onClick() {
      return onModalClose();
    } }), _react2.default.createElement('div', {
    className: (0, _classnames2.default)('mod-Modal_Wrapper', (0, _defineProperty3.default)({}, 'mod-Modal_Wrapper-' + size, size))
  }, _react2.default.createElement('button', {
    className: (0, _classnames2.default)('mod-Modal_Close', {
      'mod-Modal_Close-fill': closeFill
    }),
    type: 'button',
    onClick: function onClick() {
      return onModalClose();
    }
  }, _react2.default.createElement(_.Icon, { name: 'close-thin', className: 'am-icon-color-inherit' })), _react2.default.createElement('div', {
    className: (0, _classnames2.default)('mod-Dialog', {
      'mod-Dialog-left': dialogLeft
    })
  }, children)));
};

exports.Modal = Modal;
Modal.defaultProps = {
  dialogLeft: false,
  size: undefined,
  noscroll: false,
  closeFill: false,
  className: undefined,
  children: null
};

Modal.propTypes = {
  active: _propTypes2.default.bool.isRequired,
  dialogLeft: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf([undefined, 'thin', 'extra-thin']),
  noscroll: _propTypes2.default.bool,
  closeFill: _propTypes2.default.bool,
  onModalClose: _propTypes2.default.func.isRequired,
  className: _propTypes2.default.string,
  children: _propTypes2.default.node
};

Modal.Header = _Header.Header;
Modal.Body = _Body.Body;